import { IExperience } from '../../types/api';
import { ICountryNotice, IGetFormDataRequestMeta } from '../../types/country';
import {
  ActionsEnum,
  IAuthorizeReceiverPayload,
  IInitSuccessPayload,
  ISetKeysPayload,
  ISetWhiteLabelingPayload,
} from '../../types/store';

export const initApp = (payload?: { initString: string; pathname: string }) => ({
  type: ActionsEnum.InitApp,
  payload,
});

export const getFormDataRequestAction = (payload: ISetKeysPayload, meta?: IGetFormDataRequestMeta) => ({
  type: ActionsEnum.GetFormDataRequest,
  payload,
  ...(meta ? { meta } : {}),
});
export const getFormDataFailureAction = (payload: object | unknown, meta?: IGetFormDataRequestMeta) => ({
  type: ActionsEnum.GetFormDataFailure,
  payload,
  ...(meta ? { meta } : {}),
});
export const getFormDataSuccessAction = (payload: IInitSuccessPayload, meta?: IGetFormDataRequestMeta) => ({
  type: ActionsEnum.GetFormDataSuccess,
  payload,
  ...(meta ? { meta } : {}),
});
export const setIsFormSubmitted = (payload: boolean) => ({
  type: ActionsEnum.SetIsFormSubmitted,
  payload,
});
export const setPassword = (payload: string) => ({
  type: ActionsEnum.SetPassword,
  payload,
});
export const set2FATo = (payload: string) => ({
  type: ActionsEnum.Set2FATo,
  payload,
});
export const set2FACode = (payload: string) => ({
  type: ActionsEnum.Set2FACode,
  payload,
});
export const setWhiteLabeling = (payload: ISetWhiteLabelingPayload) => ({
  type: ActionsEnum.SetWhiteLabeling,
  payload,
});
export const authorizeReceiverRequest = (payload: IAuthorizeReceiverPayload) => ({
  type: ActionsEnum.AuthorizeReceiverRequest,
  payload,
});

export const loadIframeInitDataAction = () => ({ type: ActionsEnum.LoadIframeInitData });

export const setIframeExperienceAction = (experience: Partial<IExperience>) => ({
  type: ActionsEnum.SetIframeExperience,
  payload: experience,
});

export const setDetectedCountry = (country: string | null) => ({
  type: ActionsEnum.SetDetectedCountry,
  payload: country,
});

export const changeUserCountry = (country: string) => ({
  type: ActionsEnum.ChangeUserCountry,
  payload: country,
});

export const countryChangeStarted = (country: string) => ({
  type: ActionsEnum.CountryChangeStarted,
  payload: country,
});

export const countryChangeCommitted = (country: string) => ({
  type: ActionsEnum.CountryChangeCommitted,
  payload: country,
});

export const countryChangeFailed = () => ({ type: ActionsEnum.CountryChangeFailed });

export const setMarketplaceBlocked = () => ({ type: ActionsEnum.SetMarketplaceBlocked });

export const setPendingNotice = (payload: Pick<ICountryNotice, 'message'>) => ({
  type: ActionsEnum.SetPendingNotice,
  payload,
});

export const clearPendingNotice = () => ({ type: ActionsEnum.ClearPendingNotice });
